<template>
  <div class="dialog-warp">
    <el-form ref="info" size="small" label-position="top">
      <h3 class="title">
        审核信息：    
      </h3>
      <el-row class="dialog-form">
        <el-col>
            <el-row>
                <el-col :span="12">
                  <span>备案审核状态：</span>
                    <span v-if="vrInfo.cviState==0" class="g-blue">备案审核中</span>
                  <span v-if="vrInfo.cviState==1" class="g-green">备案成功</span>
                  <span v-if="vrInfo.cviState==2" class="g-red">备案被驳回</span>
                </el-col>
                <el-col :span="12">
                  <span>审核时间：</span>
                  <span>{{vrInfo.cviReviewTime}}</span>
                </el-col>
            </el-row>
            <el-row v-if="vrInfo.cviState==2">
              <el-col :span="24">
                <span>驳回原因：</span>
                <span>{{vrInfo.cviRejectPerson}}</span>
              </el-col>
            </el-row>
        </el-col>
      </el-row>
      <h3 class="title">
        基本信息：
        <!-- <span class="title-label-right">{{vrInfo.cviRegisterTime}} 登记</span> -->
        <!-- <span class="title-label-right">{{new Date(vrInfo.cviRegisterTime).format("yyyy-MM-dd")}} 登记</span> -->
      </h3>
      <el-row class="dialog-form">
        <el-col class="g-basic-info">
          <el-row>
            <el-col :span="24">
              <p>
                企业名称：
                <span>{{vrInfo.cviCompanyName}}</span>
              </p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <p>
                企业联系人：
                <span>{{vrInfo.cviCompanyContactor}}</span>
              </p>
            </el-col>
            <el-col :span="12">
              <p>
                联系电话：
                <span>{{vrInfo.cviTel}}</span>
              </p>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <h3 class="title">防疫信息：</h3>
      <el-row class="dialog-form">
        <el-col class="g-basic-info">
          <el-row>
            <el-col :span="12">
              <p>
                企业员工数：
                <span>{{vrInfo.cviStaffNum}}</span>
              </p>
            </el-col>
            <el-col :span="12">
              <p>
                外地（非本省）员工数：
                <span>{{vrInfo.cviNonlocalStaffNum}}</span>
              </p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <p>
                完成防疫登记员工数：
                <span>{{vrInfo.registerStaff}}</span>
              </p>
            </el-col>
                <el-col :span="12">
              <p>
                重点疫区（湖北、温台地区）员工数：
                <span>{{vrInfo.cviKeyAreaStaffNum}}</span>
              </p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <p>
                企业复工情况：
                <span>{{vrInfo.cviIsRework?'已复工':'未复工'}}</span>
              </p>
            </el-col>
              <el-col :span="12">
              <p>
                复工（包含预计）时间：
                <span>{{new Date(vrInfo.cviReworkTime).format("yyyy-MM-dd")}}</span>
              </p>
            </el-col>
          </el-row>
          <el-row v-if="vrInfo.cviIsRework">
            <el-col :span="24">
              <p>
                复工人数：
                <span>{{vrInfo.cviRealReworkNum}}</span>
              </p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <p>
                口罩等物资需求：
                <span>{{vrInfo.cviMaterialDemand}}</span>
              </p>
            </el-col>
          </el-row>
           <el-row>
            <el-col :span="24">
              <p>
                附件信息：
                <el-link
                style="display:block;margin-left:70px;"
                v-for="(item,index) in vrInfo.cviFileName"
                :key="index"
                @click.stop="downFile(vrInfo.cviFileUrl[index],item)"
                type="primary"
              >附件{{index+1}}：<span style="color:#09c;text-decoration:underline">{{item}}</span></el-link>
              </p>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import * as global from "../../config/mUtils";
import * as getData from "../../service/getData";
export default {
  data() {
    return {
      vrInfo: {
      
      }
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  props: ["id"],
  computed: {},
  methods: {
    timeFormat(time) {
      return global.toDateTime(time);
    },
    orginText(text) {
      switch (text) {
        case 1:
          return "微信提交";
        case 2:
          return "后台添加";
      }
    },
    close(type) {
      if (type === 1) {
        this.$emit("init");
      }
      this.$emit("closeDialog");
    },
    init() {
      getData
        .detail(this.id)
        .then(res => {
          if (res.data.code != "success") {
            this.$message.error(res.data.message);
            return;
          }
          this.vrInfo = res.data.data.info;
          this.vrInfo.cviFileName = this.vrInfo.cviFileName? this.vrInfo.cviFileName.split(",") : [];
          this.vrInfo.cviFileUrl = this.vrInfo.cviFileUrl? this.vrInfo.cviFileUrl.split(",") : [];
        })
        .catch(_ => {
          console.log(_);
        });
    },
    //下载
    downFile(FileUrl, FileName) {
      //参数名随意
      window.open(
        "/company/download/downloadWorkflowFileUseName?fileUrl=" +
          FileUrl +
          "&fileName=" +
          FileName
      );
    }
  },
  components: {},
  watch: {}
};
</script>
<style scoped lang="scss">
@import "../../assets/css/mixin";
</style>
<style lang="scss">
.g-assign-item {
  .el-form-item__label {
    padding: 0;
  }
}
.title-label-right {
  float: right;
  color: #169bd5;
}
.g-basic-info {
  .info-item {
    border: 1px dashed #eee;
    padding: 10px;
    padding-bottom: 0;
    margin-bottom: 10px;
  }
  p {
    margin: 5px 0;
    span {
      color: #666;
      &.red {
        color: #ff0000;
      }
      &.green {
        color: #00ae0d;
      }
    }
  }
}
.font-blod {
  font-weight: 700;
}
.g-blue{
  color:#006bff;
}
.g-green {
  color:#009966;
}
.g-red{
  color:#ff0000;
}
</style>



// WEBPACK FOOTER //
// src/components/防疫/rework-details.vue